import React from "react";
import Header from "./Header";

export default function Flight() {
  return (
    <div>
      <Header />
       <h1>Flights</h1>
     <div className="container display-flex" style={{display:'flex',marginTop:'100px'}}>
     <div class="col-md-4 mb-3" style={{marginLeft:'200px',marginRight:'20px'}}>
        <div class="card">
          <img
            class="img-fluid"
            alt="100%x280"
            src="https://images.freekaamaal.com/post_images/1566892740.png"
            style={{ width: "500px", height: "300px" }}
          />
          <div class="card-body">
            <h2 class="card-title">Domestic Flight</h2>
            {/* <p class="card-text">With supporting text below as a natural lead-in to additional content.</p> */}
          </div>
        </div>
      </div>
      <div class="col-md-4 mb-3 ">
        <div class="card">
          <img
            class="img-fluid"
            alt="100%x280"
            src="https://i.pinimg.com/originals/66/81/0e/66810e50ebc5783c6dd772251a1a189f.jpg"
            style={{ width: "500px", height: "300px" }}
          />
          <div class="card-body">
            <h2 class="card-title">International Flight</h2>
            {/* <p class="card-text">With supporting text below as a natural lead-in to additional content.</p> */}
          </div>
        </div>
      </div>
     </div>
    </div>
  );
}
